import type { Report } from '@/data/corporate-university/course/report/types';

export const calculateHours = (courses: Report[]): string => {
  return courses
    .reduce((previousValue: number, course: Report) => {
      const splitedDuration = course?.course?.duration?.split(':');

      const hours = parseInt(splitedDuration[0]);
      const minutes = parseInt(splitedDuration[1]) / 60;
      const seconds = parseInt(splitedDuration[2]) / (60 * 60);

      return (
        previousValue + (hours + minutes + seconds) * (course.progress / 100)
      );
    }, 0)
    .toFixed(2);
};
